const settingsNamespace = 'settings';
export const SET_SETTINGS = `${settingsNamespace}/SET_SETTINGS`;
export const SET_LOADING = `${settingsNamespace}/SET_LOADING`;
export const SET_COMMON_AI_ADMIN_FEEDBACK_TEMPLATES = `${settingsNamespace}/SET_COMMON_AI_ADMIN_FEEDBACK_TEMPLATES`;
